import { z } from "zod";
export const SupportClaritySurfaceV1Schema = z
    .object({
    schemaVersion: z.literal("support-clarity-surface.v1.0"),
    localTargetedProofComplete: z.literal(true),
    hostedOrExternalProofClaimed: z.literal(false),
    recordedAt: z.string().datetime(),
})
    .strict();
export function recordLocalSupportClaritySurface(recordedAt) {
    return SupportClaritySurfaceV1Schema.parse({
        schemaVersion: "support-clarity-surface.v1.0",
        localTargetedProofComplete: true,
        hostedOrExternalProofClaimed: false,
        recordedAt,
    });
}
//# sourceMappingURL=support-clarity-surface.js.map